import React from 'react'
import { Link } from 'react-router-dom'
import '../../../assests/styles/catalogue/CatalogueCards.scss'

const FolderProduct = ({ item, pathname }) => {
  const getDisplayText = () => {
    const reference =
      item.referencia && item.referencia !== null ? item.referencia : ''
    const name = item.nombre || ''

    return { reference, name }
  }

  const { reference, name } = getDisplayText()

  return (
    <Link to={{ pathname: pathname, item: item }} className='folder-card'>
      <div className='folder-card__content'>
        <h3 className='folder-card__title'>
          {reference && (
            <span className='folder-card__reference'>{reference}</span>
          )}
          {name}
        </h3>
      </div>
    </Link>
  )
}

export default FolderProduct
